// Funções utilitárias para restrição de blocos por tipo de conteúdo

export function OnlyContentTypes(contentTypes) {
  // Permite bloco apenas para os tipos informados
  return ({ contentType }) => !contentTypes.includes(contentType);
}

export function NotContentTypes(contentTypes) {
  // Restringe bloco para os tipos informados
  return ({ contentType }) => contentTypes.includes(contentType);
}

export function HasBlockField(fieldName) {
  // Permite bloco apenas se o campo existir
  return ({ data }) => data && Object.hasOwn(data, fieldName);
}

export function NotBlockField(fieldName) {
  // Restringe bloco se o campo existir
  return ({ data }) => !(data && Object.hasOwn(data, fieldName));
}

// Exemplos de uso:
// restricted: OnlyContentTypes(['Pessoa', 'Area'])
// restricted: NotContentTypes(['Noticia'])
// restricted: HasBlockField('layout')
